import { useEffect, useState } from "react";

/** Which currencies are "hot" in each active session (major currency pairs). */
export const SESSION_CURRENCIES = {
  sydney:  new Set(["AUD", "NZD"]),
  tokyo:   new Set(["JPY", "AUD", "NZD"]),
  london:  new Set(["EUR", "GBP", "CHF"]),
  newyork: new Set(["USD", "CAD"]),
};

const SESSIONS = [
  { key: "sydney",  open: 22, close:  7 },
  { key: "tokyo",   open:  0, close:  9 },
  { key: "london",  open:  8, close: 17 },
  { key: "newyork", open: 13, close: 22 },
];

export function isSessionOpen(session, utcHour, utcDay) {
  if (utcDay === 6) return false;
  if (utcDay === 0 && utcHour < 22) return false;
  if (utcDay === 5 && utcHour >= 22) return false;
  const { open, close } = session;
  if (open < close) return utcHour >= open && utcHour < close;
  return utcHour >= open || utcHour < close;
}

/** Overlap of London (08-17) and New York (13-22) → 13-17 UTC weekdays. */
export function isLondonNyOverlap(now) {
  const h = now.getUTCHours();
  const d = now.getUTCDay();
  if (d === 0 || d === 6) return false;
  return h >= 13 && h < 17;
}

/** Returns the set of currencies belonging to any currently-open session. */
export function useActiveCurrencies() {
  const [set, setSet] = useState(() => computeActive(new Date()));
  useEffect(() => {
    const id = setInterval(() => setSet(computeActive(new Date())), 60000);
    return () => clearInterval(id);
  }, []);
  return set;
}

function computeActive(now) {
  const h = now.getUTCHours();
  const d = now.getUTCDay();
  const active = new Set();
  for (const s of SESSIONS) {
    if (isSessionOpen(s, h, d)) {
      SESSION_CURRENCIES[s.key].forEach(c => active.add(c));
    }
  }
  return active;
}

/** Fires the overlap event once per calendar day (13:00 UTC on weekdays). */
export function useOverlapAlert(onStart) {
  useEffect(() => {
    const KEY = "forex.overlap_last";
    const check = () => {
      const now = new Date();
      if (!isLondonNyOverlap(now)) return;
      const stamp = now.toISOString().slice(0, 10);   // YYYY-MM-DD (UTC)
      try {
        if (localStorage.getItem(KEY) === stamp) return;
        localStorage.setItem(KEY, stamp);
      } catch { /* ignore */ }
      onStart?.();
    };
    check();
    const id = setInterval(check, 60000);
    return () => clearInterval(id);
  }, [onStart]);
}
